export default __webpack_public_path__ + "static/media/50-winery.e5f4503b.jpg";